import { ModuleBase } from '@/components';
import AnalyticsBuilderList from '@/components/analytics-builder/AnalyticsBuilderList';
import {
  AnalyticsBuilderFieldSetType,
  AnalyticsBuilderTemplateType,
  ModuleBaseModel,
  ModuleBasePropsModel,
} from '@/types';
import GDLogo from '@/assets/gd-logo.svg';
import SkyBeta from '@/assets/images/sky_beta.png';
import Image from 'next/image';

type AnalyticsBuilderModuleModel = ModuleBaseModel<
  {
    prompts: AnalyticsBuilderTemplateType[];
    fieldSets: AnalyticsBuilderFieldSetType[];
  } & ModuleBasePropsModel
>;

const AnalyticsBuilderModule = (data: AnalyticsBuilderModuleModel) => {
  const { prompts, fieldSets } = data.props;

  return (
    <ModuleBase data={data}>
      <div className="container min-h-screen">
        <div className="mb-10 flex flex-col items-center">
          <div className="flex w-full flex-row justify-center md:w-[600px]">
            <GDLogo className="mr-4 h-13 w-13 shrink-0 fill-[#3d87ce]" />
            <div className="flex flex-col">
              <div className="flex min-h-10 items-start text-2xl font-semibold text-[#3d87ce] md:h-13 md:text-[34px]">
                Analytics Builder
                <Image src={SkyBeta} alt="Beta" width={32} className="mt-2 ml-1" />
              </div>
              <div className="w-full text-base leading-5.5 text-[#1d1d1b]">
                Create a bespoke report based on the latest GlobalData analytics and data. Click{' '}
                <a
                  href="https://stylus.com/media/qhld5lvo/analyticsbuilder_howto.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 underline"
                  title="Analytics Builder Guide"
                >
                  here
                </a>{' '}
                to view a guide on this tool.
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="mb-5 flex items-center justify-between">
            <h3 className="text-lg font-semibold">Choose your report</h3>
            <p className="text-sm text-zinc-500">{prompts.length} available</p>
          </div>

          <AnalyticsBuilderList
            className="grid gap-4 md:grid-cols-2 xl:grid-cols-3"
            prompts={prompts}
            fieldSets={fieldSets}
          />
        </div>
      </div>
    </ModuleBase>
  );
};

export default AnalyticsBuilderModule;
